import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { MaterialModule } from 'src/app/shared/material/material.module';

@Component({
  selector: 'app-support-contact-dialog',
  standalone: true,
  imports: [MaterialModule, MatDialogModule],
  templateUrl: './support-contact-dialog.component.html',
  styleUrl: './support-contact-dialog.component.scss',
})
export class SupportContactDialogComponent {
  readonly email = environment.externalLinks.supportEmail;
  readonly phone = environment.externalLinks.supportPhone;
  readonly emailHref = `mailto:${this.email}`;
  readonly phoneHref = `tel:${this.phone.replace(/\D/g, '')}`;
}
